const tabs=[

"All",

"Books",

"Coffee",

"Apparel",

"Accessories",

"Greens"

];

export default function CategoryTabs(){

return(

<section className="bg-white border-b">

<div className="max-w-7xl mx-auto px-6">

<div className="flex gap-4 overflow-x-auto py-6">

{

tabs.map(tab=>(

<button

key={tab}

className="px-6 py-3 rounded-full bg-[#F5F5F5] hover:bg-[#6B8E5F] hover:text-white transition"

>

{tab}

</button>

))

}

</div>

</div>

</section>

)

}